import accordionsFaq from './pages/faq';
import setTabs from './pages/abas';
import setFullbanner from '../components/1_fullbanner';
import setWorkersCarousel from './pages/workers_swiper';
import handleConditionalLazy from '../components/conditionalLazy';
import { formMasks } from '../components/utilities';
//addImports

const Page = {
  init: function () {
    var _this = this;
    accordionsFaq();
    setTabs();
    setFullbanner();
    setWorkersCarousel();
    handleConditionalLazy();
    formMasks();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Page.init();
});
